import * as React from "react";

import "./balance-history.scss";

import {cs}          from "@Common/react/chain-services";
import {DataTableD1} from "@Common/ui-components/heavy/common/design2/data-table/data-table-d1";
import {PageList}    from "@Common/ui-components/heavy/common/design2/pagination-ui/page-list/page-list";

import {formatDate} from "../common/format-date";

export const BalanceHistory = ({adBudget}) => cs(
    () => (
        <div className="balance-history balance-history-990">

            {DataTableD1({
                pageSize: 10,
                rows: adBudget.accountUserHistory?.map((u) => ({
                    xdQaName: formatDate(u.dateCreated),
                    columns: [
                        {
                            render: () => formatDate(u.dateCreated),
                            sortValue: () => new Date(u.dateCreated).getTime(),
                            domAttrs: {
                                "xd-qa-type": "text",
                                "xd-qa-name": "Date"
                            }
                        },
                        {
                            render: () => u.systemComments,
                            domAttrs: {
                                "xd-qa-type": "text",
                                "xd-qa-name": "Activity"
                            }
                        },
                    ],
                })),
                columns,
                getFooter: ({colCount, pagination}) => ({
                    columns: [{
                        colSpan: colCount,
                        render: () => (
                            pagination.active && PageList({
                                ...pagination,
                            })
                        )
                    }],
                }),
            })}
        </div>
    ),
);

const columns = [
    {
        label: "DATE",
        className: "date",
        sortable: {
            defaultDirection: "desc",
        },
        width: "20%",
        // width: "150px",
        domAttrs: {
            "xd-qa-type": "label",
            "xd-qa-name": "DATE",
        },
    },
    {
        label: "ACTIVITY",
        className: "activity",
        width: "80%",
        // width: "150px",
        domAttrs: {
            "xd-qa-type": "label",
            "xd-qa-name": "ACTIVITY",
        },
    },
];

